//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { isEqual } from 'lodash-es'

export default {
  name: 'CategoriesQuestion',
  components: {
    CategoryInstructionsModal: () => import('./CategoryInstructionsModal.vue')
  },
  props: {
    noninteractive: {
      type: Boolean,
      default: false
    },
    questionDisplayType: {
      type: String,
      default: 'detail' // answer type indicates to QuestionList to display the answers vs details
    },
    // normal = full owner capabilities or readonly = questions can be viewed by participants but not answered
    mode: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      categoriesOpen: true,
      editCategory: false,
      loadingCategoriesQuestions: false,
      loadingQuestions: false,
      route: {
        projectid: null,
        questionid: null,
        templateid: null
      },
      categoryOwner: '',
      categoryType: 0,
      showBackToTopButton: false,
      sortCategories: false,
      selectAll: false,
      // Expand All / Collapse All — questions start collapsed; toggleKey
      // forces every question item to re-sync to `visible` even when it is
      // set to the same value twice in a row.
      visible: false,
      toggleKey: 0
      // selectAll passes true when user clicks the Select Category and false when they click Deselect Category
      // watchers check when the questionsSelected and question list changes, so it can reevaluate what action
      // is displayed to the user - this also determines whether to add or delete from the selectedQuestions list
      // if a category has all questions selected then "Deselect" mode is set
      // if category has at least 1 question unselected, the "Select Category" mode is set
    }
  },
  computed: {
    ...mapGetters({
      activeCategory: 'questions/getActiveCategory',
      activeProjectPhase: 'projects/getActiveProjectPhase',
      isMobile: 'breakpoints/mobile',
      isProjectOwner: 'user/isProjectOwner',
      isOrgAdmin: 'user/isOrgAdmin',
      isListAdmin: 'user/isListAdmin',
      isSuperAdmin: 'user/isSuperAdmin',
      isActingAsReviewer: 'user/isActingAsReviewer',
      loading: 'global/loading',
      questions: 'questions/getQuestions',
      questionsSelected: 'questions/getQuestionsSelected',
      questionsSelectActive: 'questions/getQuestionsSelectActive',
      primaryCategories: 'questions/getPrimaryCategories',
      primaryCategory: 'questions/getPrimaryCategory',
      projectIsActive: 'projects/getProjectIsActive',
      secondaryCategory: 'questions/getSecondaryCategory',
      project: 'projects/getActiveProject',
      template: 'templates/getActiveTemplate',
      categoryInstruction: 'questions/getCategoryInstruction',
      primaryCategoryInstruction: 'questions/getPrimaryCategoryInstruction',
      questionSearchTerm: 'questions/getQuestionSearchTerm',
      questionSearchMatcher: 'questions/getQuestionSearchMatcher',
      searchMatchedQuestions: 'questions/getSearchMatchedQuestions'
    }),
    questionSearchActive() {
      return !!this.questionSearchMatcher
    },
    showExpandCollapseButtons() {
      return this.selectableQuestions.length > 0
    },
    // The selected category's questions, narrowed to matches while a search is active
    selectableQuestions() {
      return this.questionSearchMatcher ? this.questions.filter(this.questionSearchMatcher) : this.questions
    },
    selectAllLabel() {
      const base = this.selectAll ? 'Deselect Category' : 'Select Category'
      return this.questionSearchActive ? `${base} (Filtered)` : base
    },
    visiblePrimaryCategories() {
      if (!this.searchMatchedQuestions) {
        return this.primaryCategories
      }
      const matched = new Set(this.searchMatchedQuestions.map(q => q.primaryCategory || 'Uncategorized'))
      return this.primaryCategories.filter(category => matched.has(category))
    },
    searchHidesAllQuestions() {
      return this.questionSearchActive && !this.loadingQuestions &&
        this.questions.length > 0 && !this.questions.some(this.questionSearchMatcher)
    },
    activeWithinPropertyDetail() {
      const { propertyid } = this.$route.params
      return propertyid !== undefined
    },
    // When viewing questions index page, always show all phases
    showAllPhases() {
      const { propertyid } = this.$route.params
      return propertyid === undefined
    },
    showCategoryButtons() {
      return (this.primaryCategories.length && !this.uncategorizedOnly) || (this.uncategorizedOnly && this.questions.length)
    },
    showEditCategoryButton() {
      return !this.sortCategories && this.activeCategory && this.activeCategory !== 'Uncategorized' && this.questionDisplayType === 'detail' &&
        (this.isProjectOwner || this.isOrgAdmin || this.isListAdmin || this.isSuperAdmin)
    },
    showDeleteAllCategoriesButton() {
      return !this.sortCategories && (this.isOrgAdmin || this.isListAdmin || this.isSuperAdmin)
    },
    uncategorizedOnly() {
      return this.primaryCategories.length === 1 && this.primaryCategories[0] === 'Uncategorized'
    },
    // A secondary category's questions are also governed by any instructions on
    // its parent primary, so those are shown above the secondary's own
    showPrimaryInstructions() {
      return !!(this.secondaryCategory && this.primaryCategoryInstruction?.instructions)
    },
    // Only worth naming the category when the parent's instructions are shown too
    instructionsLabel() {
      return this.showPrimaryInstructions ? `${this.secondaryCategory} Instructions:` : 'Instructions:'
    },
    // Uniquely identifies the category selection the instructions belong to;
    // a primary with no secondary selected carries its own instructions.
    instructionKey() {
      return this.categoryOwner && this.primaryCategory
        ? `${this.categoryOwner}::${this.primaryCategory}::${this.secondaryCategory || ''}`
        : null
    },
    canManageInstructions() {
      return !this.isActingAsReviewer && this.questionDisplayType === 'detail' &&
        (this.isProjectOwner || this.isOrgAdmin || this.isListAdmin || this.isSuperAdmin)
    }
  },
  watch: {
    questionsSelected() {
      // this condition will trigger when "select all" is chosen, when questions selected individually or by category
      this.setSelectAllMode()
    },
    questions() {
      // this condition will trigger when the category is changed and question list is refreshed
      this.setSelectAllMode()
    },
    questionSearchMatcher() {
      // the set of selectable questions changes with the search filter
      this.setSelectAllMode()
    },
    async activeProjectPhase(newVal) {
      if (newVal) {
        await this.refreshCategories()
      }
    },
    isMobile(newVal) {
      if (!newVal) {
        this.categoriesOpen = true
      }
    },
    primaryCategories(oldVal, newVal) {
      if (!isEqual(oldVal, newVal)) {
        this.editCategory = false
      }
    },
    async instructionKey() {
      // Clear first so the previously selected category's instructions are not
      // shown against the new selection while the fetch is in flight
      this.setCategoryInstruction(null)
      this.setPrimaryCategoryInstruction(null)
      if (!this.instructionKey) {
        return
      }
      await this.fetchCategoryInstruction({
        owner: this.categoryOwner,
        type: this.categoryType,
        primary: this.primaryCategory,
        secondary: this.secondaryCategory || ''
      })
      // The parent primary's instructions apply to its secondaries as well
      if (this.secondaryCategory) {
        await this.fetchPrimaryCategoryInstruction({
          owner: this.categoryOwner,
          type: this.categoryType,
          primary: this.primaryCategory
        })
      }
    }
  },
  async mounted() {
    this.loadingCategoriesQuestions = true
    this.route = { ...this.$route.params }
    this.categoryOwner = this.route.templateid ? this.route.templateid : this.route.projectid
    this.categoryType = this.route.templateid ? 1 : 2
    this.categoryToEdit = this.activeCategory
    // if viewed within a template or there is an active project set, refresh on mount,
    // otherwise watcher will update when active project is set
    if (this.categoryType === 1 || this.activeProjectPhase) {
      await this.refreshCategories()
    }
    this.loadingCategoriesQuestions = false
    window.addEventListener('scroll', this.showBackToTop)
  },
  beforeDestroy() {
    this.selectAll = false
    this.setQuestionSearchTerm('')
  },
  destroyed() {
    window.removeEventListener('scroll', this.showBackToTop)
  },
  methods: {
    ...mapActions({
      deleteQuestions: 'questions/deleteQuestions',
      fetchQuestions: 'questions/fetchQuestions',
      fetchPrimaryCategories: 'questions/fetchPrimaryCategories',
      fetchSecondaryCategories: 'questions/fetchAllSecondaryCategories',
      setActiveCategory: 'questions/setActiveCategory',
      setPrimaryCategory: 'questions/setPrimaryCategory',
      setSecondaryCategory: 'questions/setSecondaryCategory',
      setQuestionsSelected: 'questions/setQuestionsSelected',
      setQuestionsSelectedAdd: 'questions/setQuestionsSelectedAdd',
      setQuestionsSelectedDelete: 'questions/setQuestionsSelectedDelete',
      startLoading: 'global/startLoading',
      stopLoading: 'global/stopLoading',
      fetchCategoryInstruction: 'questions/fetchCategoryInstruction',
      fetchPrimaryCategoryInstruction: 'questions/fetchPrimaryCategoryInstruction',
      setCategoryInstruction: 'questions/setCategoryInstruction',
      setPrimaryCategoryInstruction: 'questions/setPrimaryCategoryInstruction',
      deleteCategoryInstruction: 'questions/deleteCategoryInstruction',
      setQuestionSearchTerm: 'questions/setQuestionSearchTerm',
      fetchSearchQuestionPool: 'questions/fetchSearchQuestionPool'
    }),
    async onSearchInput(value) {
      const term = value || ''
      const starting = !!term.trim() && !this.questionSearchTerm.trim()
      this.setQuestionSearchTerm(term)
      // Load the full question pool once per search session so matches can be
      // found in categories that have not been clicked yet
      if (starting) {
        await this.fetchSearchQuestionPool({
          owner: this.categoryOwner,
          type: this.categoryType,
          viewPhase: this.showAllPhases ? false : this.activeWithinPropertyDetail
        })
      }
    },
    async deleteAllQuestions() {
      this.loadingQuestions = true
      await this.deleteQuestions({ owner: this.categoryOwner, type: this.categoryType })
      this.loadingQuestions = false
    },
    async deleteAllQuestionsConfirm() {
      const { projectid, templateid } = this.$route.params
      const h = this.$createElement
      const customMsg = h(
        'div',
        [
          'Are you sure you want to delete ALL categories and questions for ',
          h('strong', `"${templateid ? this.template.name : this.project.name}"? `),
          `${projectid ? 'This action removes all answered questions for this project and cannot be undone!' : ''}`
        ]
      )
      const res = await this.$bvModal.msgBoxConfirm([customMsg], {
        title: 'Confirm Categories and Questions Delete!',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelVariant: 'light',
        cancelTitle: 'NO',
        footerBgVariant: 'dark',
        headerBgVariant: 'warning',
        hideHeaderClose: true,
        centered: true
      })
      if (res) {
        await this.deleteAllQuestions()
      }
    },
    getOffsetTop(el) {
      let offsetTop = 0
      while (el) {
        offsetTop += el.offsetTop
        el = el.offsetParent
      }
      return offsetTop
    },
    goToTop() {
      const offset = this.isMobile ? '75' : '100'
      const el = document.getElementById('categories-list')
      window.scrollTo(el.offsetLeft, this.getOffsetTop(el) - offset)
    },
    handleSelectQuestions() {
      if (this.selectAll) {
        this.selectableQuestions.forEach((question) => {
          // Include all questions regardless of requirement status
          this.setQuestionsSelectedAdd({ 
            _id: question._id, 
            text: question.text,
            primaryCategory: question.primaryCategory,
            secondaryCategory: question.secondaryCategory,
            tertiaryCategory: question.tertiaryCategory,
            tag: question.tag,
            type: question.type,
            choices: question.choices,
            note: question.note,
            phase: question.phase,
            required: question.required,
            loisDataField: question.loisDataField,
            requirement: question.requirement
          })
        })
      } else {
        this.selectableQuestions.forEach((question) => {
          // Include all questions regardless of requirement status
          this.setQuestionsSelectedDelete({
            _id: question._id, 
            text: question.text,
            primaryCategory: question.primaryCategory,
            secondaryCategory: question.secondaryCategory
            // We don't need the tag for deletion since we're using _id to identify questions
          })
        })
      }
    },
    setSelectAllMode() {
      // Check if all (visible, when filtered) questions in the category are selected
      const categoryHasAllSelected = this.selectableQuestions.length > 0 &&
        this.selectableQuestions.every(question => this.questionsSelected.find(qs => qs._id === question._id))
      if (categoryHasAllSelected) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    showBackToTop(e) {
      const offset = this.isMobile ? '10' : '75'
      const el = document.getElementById('categories-list')
      const pos = el ? el.getBoundingClientRect().top : 0
      if (pos < offset) {
        this.showBackToTopButton = true
      } else {
        this.showBackToTopButton = false
      }
    },
    openInstructionsModal() {
      this.$bvModal.show('modal-category-instructions')
    },
    onInstructionsSaved(instructions) {
      // The store is already updated via saveCategoryInstruction mutation;
      // emit event in case parent components need to react
      this.$emit('instructions-saved', {
        primaryCategory: this.primaryCategory,
        secondaryCategory: this.secondaryCategory,
        instructions
      })
    },
    async deleteInstructions() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Are you sure you want to delete the instructions for this category?',
        {
          title: 'Delete Instructions',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelVariant: 'light',
          cancelTitle: 'Cancel',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          centered: true
        }
      )
      if (confirmed) {
        await this.deleteCategoryInstruction({
          owner: this.categoryOwner,
          type: this.categoryType,
          primaryCategory: this.primaryCategory,
          secondaryCategory: this.secondaryCategory
        })
      }
    },
    async refreshCategories() {
      await this.fetchPrimaryCategories({ 
        owner: this.categoryOwner, 
        type: this.categoryType, 
        propertyId: this.showAllPhases ? null : this.$route.params.propertyid,
        viewPhase: this.showAllPhases ? false : this.activeWithinPropertyDetail 
      })
      this.setActiveCategory('Uncategorized')
      const sessionObj = JSON.parse(localStorage.getItem('categoryselections'))
      if (sessionObj) {
        let activeCategory
        if (sessionObj[this.categoryOwner]?.primaryCategory) {
          this.setPrimaryCategory(sessionObj[this.categoryOwner].primaryCategory)
          await this.fetchSecondaryCategories({ 
            owner: this.categoryOwner, 
            type: this.categoryType, 
            propertyId: this.showAllPhases ? null : this.$route.params.propertyid,
            viewPhase: this.showAllPhases ? false : this.activeWithinPropertyDetail 
          })
          activeCategory = sessionObj[this.categoryOwner].primaryCategory
        }
        if (sessionObj[this.categoryOwner]?.secondaryCategory) {
          this.setSecondaryCategory(sessionObj[this.categoryOwner].secondaryCategory)
          activeCategory = sessionObj[this.categoryOwner].secondaryCategory
        }
        this.setActiveCategory(activeCategory || 'Uncategorized')
        await this.fetchQuestions({ 
          owner: this.categoryOwner, 
          type: this.categoryType, 
          propertyId: this.showAllPhases ? null : this.$route.params.propertyid,
          viewPhase: this.showAllPhases ? false : this.activeWithinPropertyDetail 
        })
      } else {
        localStorage.removeItem('categoryselections')
      }
      await this.fetchQuestions({ 
        owner: this.categoryOwner, 
        type: this.categoryType, 
        propertyId: this.showAllPhases ? null : this.$route.params.propertyid,
        viewPhase: this.showAllPhases ? false : this.activeWithinPropertyDetail 
      })
      if (!this.questions.length && this.activeCategory === 'Uncategorized') {
        this.setActiveCategory('')
      }
    }
  }
}
